<i18n locale="en">
{
  "label": "Menu Item",
  "placeholder": "Search for menu item",
  "no-data": "No menu items found",
  "errors": {
    "load": "Unable to load items"
  }
}
</i18n>

<template>
  <MenuResourceSelector
    v-model="itemId"
    class="item-selector"
    :fetch-handler="getItems"
    :label="$t('label')"
    :placeholder="$t('placeholder')"
    :location="location"
    :limit="limit"
    :allow-deselect="allowDeselect"
  >
    <template #no-data>
      <NoDataCard :title="$t('no-data')" />
    </template>
    <template #menu-item="{ menuItem: item }">
      <OwnStack justify="between" align="center" row>
        <OwnStack class="pa-6 item-selector__body" spacing="1">
          <h3
            class="text-subtitle-1 item-selector__name text--truncate"
            v-text="item.name"
          ></h3>
          <p
            class="text-paragraph item-selector__description"
            v-text="item.description ?? ''"
          ></p>
        </OwnStack>
        <div
          v-if="item.image"
          :style="{
            backgroundImage: `url('${item.image}')`,
          }"
          class="item-selector__image flex-shrink-0"
        />
      </OwnStack>
    </template>
  </MenuResourceSelector>
</template>

<script>
import { itemsApi2 } from '@/api'

import notify from '@/mixins/notify'

import { OwnStack } from '@/ui'

import { mapModel } from '@/utils/computed'

import MenuResourceSelector from '../components/menu-resource-selector/MenuResourceSelector.vue'
import NoDataCard from '../components/menu-resource-selector/NoDataCard.vue'

export default {
  name: 'ItemSelector',
  components: {
    MenuResourceSelector,
    NoDataCard,
    OwnStack,
  },
  mixins: [notify],
  props: {
    /** Whether to allow the user to deselect an item by clicking */
    allowDeselect: { type: Boolean, default: false },

    /** Maximum items to show in the list */
    limit: { type: [String, Number], default: '10' },

    /** The ID of the location to search under */
    location: { type: [String, null], default: null },

    /**
     * @model
     *
     * The Item ID
     */
    value: { type: String, default: null },
  },
  computed: {
    ...mapModel('itemId'),
  },
  methods: {
    async getItems(filter) {
      try {
        return await itemsApi2.getGroup(filter)
      } catch (error) {
        this.$notify(this.$t('errors.load'), 'error')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.item-selector {
  &__image {
    height: 120px;
    width: 120px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }

  &__body {
    min-width: 0;
  }

  &__description {
    max-width: 100%;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
  }
}
</style>
